import React, { Component, Fragment } from "react";
import UploadForm from "./UploadForm";
import PostUploadForm from "./PostUploadForm";
import Header from "../structure/Header/Header";
import './UploadContainer.css';

class UploadContainer extends Component {
  
  render(){
    const { from } = this.props;
    return(
      <Fragment>
        <Header />
        <div className="upload-container">
          {from ? <PostUploadForm {...this.props}/> : <UploadForm />}
        </div>
      </Fragment>
    );
  }
}
export default UploadContainer;